import { darken } from "@material-ui/core/styles";
import { Avatar, Button as MuiButton } from "@material-ui/core";
import styled from "styled-components";

export const Layout = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  height: 100vh;
`;

export const Wrapper = styled.div`
  background-color: white;
  box-shadow: 0 0 15px #ddd;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  padding: 40px;
  width: 360px;
  position: relative;
  transition: 0.3s;
  &:hover {
    box-shadow: 2px 2px 20px #ccc;
  }
`;

export const IconLogin = styled(Avatar)`
  background-color: #dd4a39;
  position: absolute;
  left: -20px;
  top: -20px;
`;

export const Button = styled(MuiButton)`
  background-color: #dd4a39;
  color: white;
  margin-top: 20px;
  padding: 6px 24px;
  transition: 0.3s;

  &.Mui-disabled {
    background-color: #ddd;
  }

  &:hover {
    background-color: ${darken("#dd4a39", 0.1)};
    padding: 6px 30px;
  }
`;
